import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoImage from '../assets/logo-removebg-preview.png';
import maghil from '../assets/fone.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '/', isExternal: false },
    { name: 'About Us', href: '/#about', isExternal: true },
    { name: 'Gallery', href: '/#gallery', isExternal: true },
    { name: 'Menu', href: '/menu', isExternal: false },
    { name: 'Contact', href: '/#contact', isExternal: true }
  ];


  const socialLinks = [
    { name: 'Facebook', icon: 'fab fa-facebook-f', href: '#' },
    { name: 'Instagram', icon: 'fab fa-instagram', href: '#' },
    { name: 'Twitter', icon: 'fab fa-twitter', href: '#' },
    { name: 'Yelp', icon: 'fab fa-yelp', href: '#' }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Column 1 - Restaurant Info */}
          <div className="footer-column">
            <div className="footer-section">
              <div className="footer-logo">
                <img src={logoImage} alt="Rajni Logo" className="footer-logo-image" />
                <p className="logo-tagline">Authentic Indian Cuisine</p>
              </div>
              <p className="footer-description">
                Experience the rich flavors and traditions of India at Rajni. 
                We bring you authentic Indian cuisine crafted with love and 
                the finest ingredients from the heart of India.
              </p>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    className="social-link"
                    aria-label={social.name}
                  >
                    <i className={social.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="footer-column">
            <div className="footer-section">
              <h4 className="footer-title">Quick Links</h4>
              <ul className="footer-links">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    {link.isExternal ? (
                      <a href={link.href} className="footer-link">
                        {link.name}
                      </a>
                    ) : (
                      <Link to={link.href} className="footer-link">
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Column 3 - Contact Info */}
          <div className="footer-column">
            <div className="footer-section">
              <h4 className="footer-title">Location</h4>
              <div className="locations-grid">
                <div className="location-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <div>
                    <p>296 US-46</p>
                    <p>Parsippany, NJ</p>
                    <p className="phone-number">+1 (973) 396-8666</p>
                  </div>
                </div>
               
               
                
              </div>
              
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="newsletter-section">
          <div className="newsletter-content">
            <div className="newsletter-text">
              <h4 className="newsletter-title">Stay Updated</h4>
              <p className="newsletter-description">
                Subscribe to our newsletter for special offers, new menu items, and events.
              </p>
            </div>
            <form className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email address"
                className="newsletter-input"
                required
              />
              <button type="submit" className="newsletter-btn">
                <i className="fas fa-paper-plane"></i>
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {currentYear} Rajni Restaurant. All rights reserved.</p>
            </div>
            <div className="footer-bottom-links">
              <a href="#" className="bottom-link">Privacy Policy</a>
              <a href="#" className="bottom-link">Terms of Service</a>
              <a href="#" className="bottom-link">Cookie Policy</a>
            </div>
          </div>
          
          {/* Powered by Maghil */}
          <div className="powered-by-section">
            <p className="powered-by">2025 © Rajni Indian Restaurant. Powered by <span className="maghil-text"><a href="https://maghil.com" target="_blank" rel="noopener noreferrer"><img src={maghil} alt="Maghil" /></a></span></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
